import React, { useEffect } from "react";
import "./App.css";

import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import theme from "./theme";
import SnackbarAlert from "./Components/SnackbarAlert";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { BrowserRouter, useLocation } from "react-router";
import { initAnalytics, trackPageView } from "./utils/analytics";
import { LocaleProvider } from "./i18n/LocaleProvider";
import { AuthProvider } from "./providers/AuthProvider";
import { AppRoutes } from "./i18n/AppRoutes";
import { DASHBOARD_PATH } from "./constants/paths";
import "./i18n";

initAnalytics();

export { DASHBOARD_PATH };

/** Matches Navbar Toolbar minHeight so dashboard viewport math stays exact. */
const NAVBAR_HEIGHT_PX = 80;

const AppContent = () => {
  const location = useLocation();
  const isDashboard = location.pathname === DASHBOARD_PATH;

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return (
    <LocaleProvider>
      <AuthProvider>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            bgcolor: "background.default",
            ...(isDashboard
              ? {
                  height: "100dvh",
                  overflow: "hidden",
                  minHeight: 0,
                }
              : null),
          }}
        >
          <Navbar />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              bgcolor: "background.default",
              ...(isDashboard
                ? {
                    height: `calc(100dvh - ${NAVBAR_HEIGHT_PX}px)`,
                    minHeight: 0,
                    overflow: "hidden",
                  }
                : null),
            }}
          >
            <AppRoutes />
          </Box>
          {!isDashboard && <Footer />}
        </Box>
      </AuthProvider>
    </LocaleProvider>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <BrowserRouter>
        <SnackbarAlert />
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
